import { ReactNode } from 'react'
import { Navbar } from './Navbar'
import { Footer } from './Footer'
import { PerksBanner } from './PerksBanner'
import { MobileCallBar } from './MobileCallBar'

interface PageWrapperProps {
  children: ReactNode
  hideNav?: boolean
  hideFooter?: boolean
  /**
   * Suppress the sticky mobile "Text us now" bar. Set on plumber profile pages:
   * pinned across a specific plumber's profile, our support number reads as that
   * plumber's number.
   */
  hideCallBar?: boolean
  /**
   * Page-specific bar fixed to the bottom of the viewport on small screens
   * (e.g. the plumber profile's sticky "Book online" bar). The bar component
   * is expected to hide itself at lg+; main gets matching bottom padding.
   */
  bottomBar?: ReactNode
}

export function PageWrapper({ children, hideNav = false, hideFooter = false, hideCallBar = false, bottomBar }: PageWrapperProps) {
  const showCallBar = !hideNav && !hideCallBar && !bottomBar
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {!hideNav && <PerksBanner />}
      {!hideNav && <Navbar />}
      <main className={`flex-1 ${showCallBar ? 'pb-16 sm:pb-0' : bottomBar ? 'pb-20 lg:pb-0' : ''}`}>{children}</main>
      {!hideFooter && <Footer />}
      {showCallBar && <MobileCallBar />}
      {bottomBar}
    </div>
  )
}
